import { isSavedByItem } from "@smartrr/shared/utils/containsSavedBy";

/**
 * Checks if a variant is a SavedBy (package protection) item
 * SavedBy items are identified by sku or variant name containing "savedby" (normalized: lowercase, no spaces)
 *
 * @param vnt - The variant object to check. Can be null or undefined.
 * @returns true if the variant is a SavedBy item, false otherwise
 */
export function isSavedByVariant(
  vnt: { sku?: string | null; purchasableVariantName?: string | null } | null | undefined
): boolean {
  if (!vnt) {
    return false;
  }
  return isSavedByItem({
    sku: vnt.sku,
    variantName: vnt.purchasableVariantName,
  });
}
